import styled from "@emotion/styled"

const DateTimeWrapper = styled.div`
  input {
    height: 0.4375em;
  }
`

export default DateTimeWrapper
